/* Katier — JS propio. Vanilla, sin librerias. Cada init comprueba su elemento. */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("mt-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el, i) {
      if (el.style.getPropertyValue("--i") === "") el.style.setProperty("--i", (i % 6));
      io.observe(el);
    });
  }

  /* ---- Marquesinas en bucle: duplica el contenido para scroll continuo ---- */
  function initMarquee() {
    document.querySelectorAll(".mt-sellos__track, .mt-rev__track").forEach(function (track) {
      if (track.dataset.cloned === "1") return;
      if (reduce && track.classList.contains("mt-rev__track")) return;
      var html = track.innerHTML;
      track.innerHTML = html + html;
      track.dataset.cloned = "1";
    });
  }

  /* ---- FAQ acordeon ---- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector(".mt-faq__q");
      var a = item.querySelector(".mt-faq__a");
      if (!q || !a) return;
      q.setAttribute("aria-expanded", "false");
      q.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        item.classList.toggle("is-open", !open);
        q.setAttribute("aria-expanded", String(!open));
        a.style.maxHeight = open ? "0px" : (a.scrollHeight + "px");
      });
    });
    window.addEventListener("resize", function () {
      document.querySelectorAll(".mt-faq__item.is-open .mt-faq__a").forEach(function (a) {
        a.style.maxHeight = a.scrollHeight + "px";
      });
    });
  }

  /* ---- Galeria de producto ---- */
  function initGallery() {
    var gal = document.querySelector("[data-mt-gallery]");
    if (!gal) return;
    var main = gal.querySelector("[data-mt-gallery-main]");
    var thumbs = gal.querySelectorAll("[data-mt-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src");
        var alt = t.getAttribute("data-alt") || "";
        if (src) { main.src = src; main.alt = alt; }
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* ---- Selector de variantes (solo si hay mas de una) ---- */
  function initVariants() {
    var form = document.querySelector("[data-mt-product-form]");
    if (!form) return;
    var dataEl = document.getElementById("mt-variant-data");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll("[data-mt-option]");
    if (!selects.length) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector("[data-mt-price]");
    var btn = form.querySelector("[data-mt-add]");

    function money(cents) {
      return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    }
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.getAttribute("data-label-add") : btn.getAttribute("data-label-sold");
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", update); });
    update();
  }

  function boot() {
    initReveal();
    initMarquee();
    initFaq();
    initGallery();
    initVariants();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
